import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, timeout } from 'rxjs';
import { IBaseResponse } from '../../utilities/http-utilities.service';
import { SKIP_SCREEN_LOCK } from '../interceptors/screen-lock.interceptor';
import { EScreenLockEntityType, IScreenLockVerifyResult } from './screen-lock.interface';

/**
 * A hung verify must not hold the keypad forever: the keypad blocks input while a check is in flight, and on
 * a kiosk with no keyboard that leaves the operator with nothing to press. See SCREEN_LOCK_CONTEXT.md.
 */
export const SCREEN_LOCK_VERIFY_TIMEOUT_MS = 15_000;

@Injectable({ providedIn: 'root' })
export class ScreenLockApiService {
  private readonly http = inject(HttpClient);

  /** Verifies the PIN server-side; the PIN is never held in the browser. See SCREEN_LOCK_CONTEXT.md. */
  public verifyPin(
    entityType: EScreenLockEntityType,
    entityId: number,
    pin: string,
  ): Observable<IBaseResponse<IScreenLockVerifyResult>> {
    // No `Skip-Error-Message-And-Redirect`: a wrong PIN is a 200 with `isValid: false`, so real HTTP failures (e.g. 401) still follow the normal flow.
    // `SKIP_SCREEN_LOCK` keeps the lock out of its own verify call: a 423 here would open a second keypad.
    return this.http
      .post<
        IBaseResponse<IScreenLockVerifyResult>
      >('screen-lock/verify', { entityId, entityType, pin }, { context: new HttpContext().set(SKIP_SCREEN_LOCK, true) })
      .pipe(timeout(SCREEN_LOCK_VERIFY_TIMEOUT_MS));
  }
}
